import React from 'react';
import type { FC } from 'react';

import {
	LoadableAfterPaint,
	LoadableActivatable,
	ActivationTriggerType,
} from '@confluence/loadable';

import type { EndOfPageRecommendationProps } from './EndOfPageRecommendation.tsx';
import { SSR_PARTIAL_COMPONENT } from '@confluence/ssr-utilities/entry-points/ssrPartialSuccess.ts';

export const EndOfPageRecommendationLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EndOfPageRecommendation" */ './EndOfPageRecommendation.tsx'
			)
		).EndOfPageRecommendation,
});

export const EndOfPageRecommendationLoaderWithScrollIntoView = LoadableActivatable({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-EndOfPageRecommendation" */ './EndOfPageRecommendation.tsx'
			)
		).EndOfPageRecommendation,
	triggers: [
		{
			type: ActivationTriggerType.SCROLL_INTO_VIEW,
		},
	],
	ssrSuccessCheckName: SSR_PARTIAL_COMPONENT.EndOfPageRecommendation,
});

export const EndOfPageRecommendationFinalLoader: FC<EndOfPageRecommendationProps> = (props) => {
	return <EndOfPageRecommendationLoaderWithScrollIntoView {...props} />;
};
